import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoSettings24 = t0 => {
  const $ = _c(10);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  if ($[2] !== iconColor) {
    t2 = <path d="M9.12609 6.47467L7.63217 6.12992C7.3522 6.06531 7.0587 6.14949 6.85554 6.35265L6.35247 6.85572C6.1493 7.05889 6.06513 7.35239 6.12974 7.63235L6.47449 9.12627C6.55243 9.46402 6.41315 9.81475 6.12475 10.007L4.66259 10.9818C4.43075 11.1364 4.2915 11.3965 4.2915 11.6752V12.3249C4.2915 12.6035 4.43075 12.8637 4.66259 13.0183L6.12475 13.993C6.41315 14.1853 6.55243 14.536 6.47449 14.8738L6.12974 16.3677C6.06513 16.6477 6.1493 16.9412 6.35247 17.1444L6.85554 17.6474C7.0587 17.8505 7.3522 17.9348 7.63217 17.8701L9.12609 17.5254C9.46384 17.4474 9.81457 17.5867 10.0068 17.8751L10.9816 19.3373C11.1362 19.5691 11.3963 19.7084 11.675 19.7084H12.3247C12.6033 19.7084 12.8635 19.5691 13.0181 19.3373L13.9928 17.8751C14.1851 17.5867 14.5358 17.4474 14.8736 17.5254L16.3675 17.8701C16.6475 17.9348 16.941 17.8505 17.1442 17.6474L17.6472 17.1444C17.8503 16.9412 17.9346 16.6477 17.8699 16.3677L17.5252 14.8738C17.4473 14.536 17.5865 14.1853 17.8749 13.993L19.3371 13.0183C19.5689 12.8637 19.7082 12.6035 19.7082 12.3249V11.6752C19.7082 11.3965 19.5689 11.1364 19.3371 10.9818L17.8749 10.007C17.5865 9.81475 17.4473 9.46402 17.5252 9.12627L17.8699 7.63235C17.9346 7.35239 17.8503 7.05889 17.6472 6.85572L17.1442 6.35265C16.941 6.14949 16.6475 6.06531 16.3675 6.12992L14.8736 6.47467C14.5358 6.55261 14.1851 6.41334 13.9928 6.12493L13.0181 4.66277C12.8635 4.43094 12.6033 4.29169 12.3247 4.29169H11.675C11.3963 4.29169 11.1362 4.43094 10.9816 4.66277L10.0068 6.12493C9.81457 6.41334 9.46384 6.55261 9.12609 6.47467Z" stroke={iconColor} strokeWidth={2} strokeLinejoin="round" />;
    t3 = <path d="M14.2918 12C14.2918 13.2656 13.2658 14.2916 12.0002 14.2916C10.7345 14.2916 9.7085 13.2656 9.7085 12C9.7085 10.7343 10.7345 9.70831 12.0002 9.70831C13.2658 9.70831 14.2918 10.7343 14.2918 12Z" stroke={iconColor} strokeWidth={2} strokeLinejoin="round" />;
    $[2] = iconColor;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2 || $[8] !== t3) {
    t4 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default IcoSettings24;